<template>
	<section class="page-templates">
		<header-page
			actions
			name="apage-templates"
			:title="title"
			@run-action="runAction"
		/>
		<v-layout row align-end class="report-lista">
			<v-flex xs11>
				<report-list
					:check-all="checkAll"
					:columns="columns"
					:current-page="params.page"
					:last-page="table.lastPage"
					:rows="rows"
					@click-icon="clickIcon"
					@on-page="onPage"
					@on-search="onSearch"
					@on-selected-all="onSelectedAll"
					@row-is-selected="rowIsSelected"
				>
				</report-list>
			</v-flex>
		</v-layout>
		<action-bar
			:value-disabled="actionsDisabled"
			class="action-mobile"
			:resource-uri="$route.name"
			@run-action="runAction"
		/>
		<action-sidebar
			:title="action.title"
			:value="action.visible"
			@close-modal="closeModal"
		>
		<v-layout row align-end class="report-lista">
			<v-flex xs11>
			<report-list-asign
				:current-page="params.page"
				:last-page="table.lastPage"
				:rows="asignRow"
				@click-icon="clickIcon"
				@on-delete="onDelete"
				@on-page="onPage"
				@on-search="onSearch"
			>
			</report-list-asign>
		</v-flex>
		</v-layout>
		</action-sidebar>
		<v-dialog v-model="dialogReport" persistent max-width="333">
			<v-card>
				<v-divider></v-divider>
				<v-card-text>
					<v-flex pb-4 pt-2 text-xs-center class="text-dialog">
						¿Estas seguro que desea
						{{
							dataSelected.length > 1
								? 'asignar los reportes'
								: 'asignar el reporte'
						}}
						?
					</v-flex>
				</v-card-text>
				<v-card-actions class="background-dialog" pa-0>
					<v-layout row wrap justify-center ma-0 pa-1>
						<v-btn
							@click="closeDialogReport"
							color="#ff002b"
							:style="`color: #fff !important`"
							small
							>NO</v-btn
						>
						<v-btn
							color="teal darken-1"
							:style="`color: #fff !important`"
							small
							@click="assignReport"
							>SI</v-btn
						>
					</v-layout>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogDelete" persistent max-width="333">
			<v-card>
				<v-divider></v-divider>
				<v-card-text>
					<v-flex pb-4 pt-2 text-xs-center class="text-dialog">
						¿Estas seguro que deseas eliminar este Template
						?
					</v-flex>
				</v-card-text>
				<v-card-actions class="background-dialog" pa-0>
					<v-layout row wrap justify-center ma-0 pa-1>
						<v-btn
							@click="closeDialogDelete"
							color="#ff002b"
							:style="`color: #fff !important`"
							small
							>NO</v-btn
						>
						<v-btn
							color="teal darken-1"
							:style="`color: #fff !important`"
							small
							@click="deleteTemplate"
							>SI</v-btn
						>
					</v-layout>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</section>
</template>

<script>

import actionBar from '@/components/shared/action-bar/action-bar';
import actionSidebar from '@/components/shared/action-sidebar';
import reportList from '@/components/reports-list/report-list';
import reportListAsign from '@/components/reports-list/report-list-asign';
import dictionaryFormRemove from '@/components/dictionary/dictionary-form-remove';
import appButton from '@/components/shared/app-button';

function data() {
	return {
		action: {
			code: '',
			title: '',
			visible: false,
		},
		rows: [],
		asignRow: [],
		columns: [
			{ id: 1, name: 'Name', value: 'code', checked: true, visible: true },
			{
				id: 2,
				name: 'Código',
				value: 'description',
				checked: true,
				visible: true,
			},
		],
		limit: 10,
		checkAll: false,
		selectedRow: {
			id: null,
		},
		dialogReport: false,
		dataSelected: [],
		templateId: null,
		dialogDelete: false,
	};
}

function rowIsSelected() {
	this.checkAll = this.rows.every(r => r.isSelected);
	this.dataSelected = this.rows.filter(r => r.isSelected);
}

function onSelectedAll(checked) {
	this.checkAll = checked;
	this.rows = this.rows.map((row) => {
		const newRow = { ...row };
		newRow.isSelected = checked;
		return newRow;
	});
	this.dataSelected = this.rows.filter(r => r.isSelected);
}

function onDelete(row) {
	this.templateId = row.id;
	this.dialogDelete = true;
}

async function loadData() {
	const templates = await this.loadData('templates');
	const asignTemplates = await this.loadData('company-template');
	this.asignRow = asignTemplates.records;
	this.rows = templates.records;
	const uniqueArr = this.rows.filter(
		item2 => !this.asignRow.some(item1 => item1.code === item2.code),
	);
	this.rows = uniqueArr;
	return this.rows;
}

async function assignReport() {
	const body = {
		masterTemplateCodes: this.dataSelected.map(p => p.code),
	};
	try {
		await this.$http.post('company-template-config', body);
		this.showNotification('Los reportes fueron asignados correctamente.');
		await loadData.call(this);
		this.dataSelected = [];
		this.closeDialogReport();
	} catch (error) {
		if (error.status === 400) {
			this.dialogReport = false;
			if (error.data.message === 'TEMPLATE_EXIST') {
				this.showGenericError('El reporte ya asignado anteriormente.');
			}
		} else {
			this.showGenericError();
		}
	}
}

async function deleteTemplate() {
	try {
		await this.$http.delete(`company-template/${this.templateId}`);
		this.showNotification('El reporte fue eliminado correctamente.');
		await loadData.call(this);
		this.action.visible = false;
		this.closeDialogDelete();
	} catch (error) {
		if (error.status === 400) {
			this.dialogReport = false;
			if (error.data.message === 'TEMPLATE_EXIST') {
				this.showGenericError('El reporte ya asignado anteriormente.');
			}
		} else {
			this.showGenericError();
		}
	}
}

function closeDialogReport() {
	this.dialogReport = false;
}

function closeDialogDelete() {
	this.dialogDelete = false;
}

function closeModal(reloadList) {
	this.action.code = '';
	this.action.title = '';
	this.action.visible = false;
	this.selectedRow.id = 0;
	if (reloadList) {
		loadData.call(this);
	}
}
function actionsDisabled() {
	const disabledAction = this.dataSelected.length >= 1;
	return [{ code: 'asign-report-account', disabled: !disabledAction }];
}

async function created() {
	await loadData.call(this);
}

function customerId() {
	return Number(this.$route.query.customerId);
}

function moduleId() {
	return Number(this.$route.query.id);
}

async function onPage(page) {
	this.params.page = page;
	await loadData.call(this);
}

async function onSearch(value) {
	this.params.page = 1;
	this.$set(this.params, 'search', value || null);
	await loadData.call(this);
}

function runAction({ name, code }) {
	if (code === 'asign-report-account') {
		this.dialogReport = true;
	} else {
		this.action.title = name;
		this.action.code = code;
		this.action.visible = true;
	}
}

function subsidiaryId() {
	return Number(this.$route.query.subsidiaryId);
}

function title() {
	return `${this.$route.query.name} / ${this.$route.meta.title}`;
}

export default {
	name: 'page-templates',
	created,
	components: {
		actionBar,
		actionSidebar,
		appButton,
		reportListAsign,
		reportList,
		dictionaryFormRemove,
	},
	computed: {
		customerId,
		moduleId,
		subsidiaryId,
		title,
		actionsDisabled,
	},
	data,
	methods: {
		assignReport,
		onSelectedAll,
		deleteTemplate,
		closeDialogDelete,
		onDelete,
		rowIsSelected,
		closeModal,
		onPage,
		onSearch,
		runAction,
		closeDialogReport,
	},
};
</script>
<style lang="scss" scoped>
.report-lista {
	@include flex-center;
}
</style>



// WEBPACK FOOTER //
// src/pages/company-templates/page-templates.vue